import ResizableScene from "./ResizableScene";

export default class RotateDevice extends ResizableScene {
    create(): void {
        const graphics: Phaser.GameObjects.Graphics = this.add.graphics({ x: 0, y: 0 });
        graphics.setInteractive();
        graphics.fillStyle(0x000000, 1);
        graphics.fillRect(0, 0, this.game.scale.width, this.game.scale.height);

        const rotateImage: Phaser.GameObjects.Image = this.add.image(0, 0, "rotateDevice", null);
        rotateImage.setInteractive();

        const scale = this.game.scale.width / rotateImage.width;
        rotateImage.scaleX = scale;
        rotateImage.scaleY = scale;
        rotateImage.width *= scale;
        rotateImage.height *= scale;

        const width = Math.min(this.viewport.width, 1024);
        const vw = this.game.scale.width;
        const vh = this.game.scale.height;
        const bounds = new Phaser.GameObjects.Rectangle(this, vw / 2, vh / 2, width, 576); //todo stop creating every time
        Phaser.Display.Align.In.Center(rotateImage, bounds);
    }

    update(time: number, delta: number): void {
        super.update(time, delta);

        this.game.scene.bringToTop(this);

        if (this.game.scale.width > this.game.scale.height) {
            this.scene.stop("RotateDevice");
        }
    }
}
